import {Component, OnInit, Input} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {DialogService} from '@rbaip/ui-component';
import {OpportunityContract} from '../../shared/domain/opportunity';
import {Asset, assetMessage, AuditAssetMove} from '../../shared/domain/item';
import {ContractStatus} from '../../shared/domain/contract';
import {MoveAssetsComponent} from '../move-assets/move-assets.component';
import {ItemSummaryAssetsService} from '../../shared/asset/item-summary-assets.service';
import { ItemSummaryItemService } from '../../shared/asset/item-summary-item.service';

@Component({
  selector: 'lib-item-summary-reconsign-asset',
  templateUrl: './reconsign-asset.component.html',
  styleUrls: ['./reconsign-asset.component.scss']
})
export class ReconsignAssetComponent implements OnInit {

  @Input() selectedItems: Asset[];
  @Input() itemService: ItemSummaryItemService;
  @Input('auditAssetMove') auditAssetMove: AuditAssetMove;

  public disableResellButton: boolean;

  private selectedContract: OpportunityContract;
  private itemToReconsign: Asset;
  private operationalEntityException = 'INVALID_OPERATIONAL_ENTITY';

  constructor(private dialogRef: MatDialogRef<MoveAssetsComponent>,
              private dialogService: DialogService,
              private assetsService: ItemSummaryAssetsService) {
  }

  ngOnInit() {
    this.itemToReconsign = this.selectedItems[0];
    this.validateAsset();
  }

  public selectContract(selectedContract): void {
    this.selectedContract = selectedContract;
  }

  public isReconsignButtonEnabled(): boolean {
    return !!this.selectedContract && !this.disableResellButton;
  }

  public reconsignAsset(): void {
    if (!this.validateReconsign()) {
      return;
    }
    this.dialogService.showProgress();
    this.itemService.reconsignAsset(this.itemToReconsign.equipId, this.selectedContract.ipContractId)
      .subscribe(itemResponse => {
        let message;
        if (itemResponse && itemResponse.error) {
          if (itemResponse.message === this.operationalEntityException) {
            this.dialogService.showMessageDialog(assetMessage.reconsignOperationalEntityError);
            this.dialogService.hideProgress();
            return;
          } else {
            message = itemResponse.message;
          }
        } else if (itemResponse.status === 'Success') {
          message = 'Asset re-consigned successfully.';
        } else {
          message = itemResponse.message;
        }
        this.dialogService.showMessage(message);
        this.dialogRef.close(true);
        this.dialogService.hideProgress();
      });
  }

  private validateReconsign(): boolean {
    if (ContractStatus.isFinalized(this.selectedContract.shContractStatus)) {
      this.dialogService.showMessageDialog(assetMessage.shContractFinalizedMoveError);
      return false;
    } else if (!this.selectedContract.ipContractId) {
      this.dialogService.showMessageDialog(assetMessage.contractMoveOppWithNoContractError);
      return false;
    }
    return true;
  }

  private validateAsset(): void {
    this.checkRelistedItems();
  }

  private checkRelistedItems(): void {
    const relistedItemsYn = this.selectedItems.some(asset => asset.destinationEquipmentId);
    if (relistedItemsYn) {
      this.disableResellButton = true;
      this.auditAssetMove.destinationType = null;
      this.dialogService.showMessageDialog(assetMessage.assetMoveToRelistedConfirmation);
    }
  }

}
